import React from 'react';

export default ({ width = 29, height = 29 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 29 29"
  >
    <path
      fillRule="evenodd"
      d="M18.385 11.314L16.97 9.899l-2.829 2.829-2.828-2.829-1.415 1.415 2.829 2.828-2.829 2.829 1.415 1.414 2.828-2.829 2.829 2.829 1.414-1.414-2.829-2.829 2.829-2.828zm2.828-4.243c-3.889-3.889-10.253-3.889-14.142 0-3.889 3.89-3.889 10.253 0 14.142 3.89 3.89 10.253 3.89 14.142 0 3.89-3.889 3.89-10.253 0-14.142zM8.485 19.8c-3.111-3.111-3.111-8.202 0-11.314 3.112-3.111 8.203-3.111 11.314 0 3.111 3.112 3.111 8.203 0 11.314-3.111 3.111-8.202 3.111-11.314 0z"
    />
  </svg>
);
